import {AttrsSchema} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import {BaseButtonAttrs, ButtonBase} from '../base/button';
import {template} from './template';
import css from './index.inline.styl';
import {ButtonBarTheme} from './types';

interface ButtonBarJsxProps {
  attrs?: ButtonBarAttrs;
}

type ButtonBarAttrs = BaseButtonAttrs & Attrs;

type Attrs = {
  'arrow-next'?: boolean;
  theme?: ButtonBarTheme;
};

export class ButtonBar extends ButtonBase<Attrs> {
  static get attrsSchema(): AttrsSchema<ButtonBarAttrs> {
    return {
      ...super.attrsSchema,
      'arrow-next': `boolean`,
      theme: {type: `string`, enum: Object.values(ButtonBarTheme), default: ButtonBarTheme.Primary},
    };
  }

  get config() {
    return Object.assign(super.config, {
      css,
      template,
    });
  }
}

export const ButtonBarEl = defineAndMakeJsxFactory<ButtonBarJsxProps>(`mp-button-bar`, ButtonBar);
export const ButtonBarReact = panel2react<ButtonBarJsxProps>(`mp-button-bar`, ButtonBar);
